<template lang="pug">
  div#about
    v-card.imageTop(width="100%" height="400",dark)
      v-img(src="../assets/img/1592904485.jpg" height="100%"  )
        v-row(align="center" style="height:100%")
          v-col(cols="12" align="center")
            p.display-2.font-weight-black.about-title City of Refuge's
            p.display-2.font-weight-black.about-title Story
    router-view 
</template>

<script>
export default {
  created() {
    console.log('TCL: created -> this.$route', this.$route.path);
    this.$emit('inabout');
  }
};
</script>

<style lang="stylus" scoped>
.about-title
  font-family 'Cardo', 'san-serif' !important
</style>
